var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAvistapp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 43.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3d4543;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#a50064;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -459.41,
    y1: 1253.45,
    x2: -459.15,
    y2: 1253.12,
    gradientTransform: "matrix(74.72, 0, 0, -57.18, 34363.4, 71695.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#565e5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#747b79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#959a98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#acb0af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#babdbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bfc2c1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16907",
    "data-name": "Group 16907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16160",
    "data-name": "Path 16160",
    className: "cls-1",
    d: "M124.6,1.37a4.49,4.49,0,0,0-3-1.15,4.58,4.58,0,0,0-3.07,1.15,4,4,0,0,0-1.3,3.17,4.14,4.14,0,0,0,1.3,3.18,4.68,4.68,0,0,0,3.07,1.15,4.52,4.52,0,0,0,3.08-1.15,4,4,0,0,0,1.3-3.18,4.1,4.1,0,0,0-1.33-3.17",
    transform: "translate(-0.5 -0.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16161",
    "data-name": "Path 16161",
    className: "cls-1",
    d: "M200.5,11.71v3h-.6V12.33h0l-.75,2.35h-.45L198,12.33h0v2.35h-.57v-3h1l.58,2h0l.58-2Z",
    transform: "translate(-0.5 -0.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16162",
    "data-name": "Path 16162",
    className: "cls-1",
    d: "M197.08,12.23h-1v2.45h-.63V12.23h-1v-.52h2.55Z",
    transform: "translate(-0.5 -0.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16163",
    "data-name": "Path 16163",
    className: "cls-1",
    d: "M192.38,17.17a7.86,7.86,0,0,0-1.83-3.3,8.25,8.25,0,0,0-3.42-2.07,17,17,0,0,0-5.3-.73,20.5,20.5,0,0,0-2.48.13c-.8.07-1.6.17-2.32.3s-1.43.25-2.05.37c-.33.08-.63.15-.9.23a.32.32,0,0,0-.25.37c.15,1.8.27,3.58.42,5.38a.35.35,0,0,0,.38.31h.07a14.6,14.6,0,0,1,2.75-.63,24.82,24.82,0,0,1,3.55-.25c1.78,0,3,.35,3.75,1.08a3.82,3.82,0,0,1,1.05,2.82v.43s-.05.07-.1.07c-.5-.11-1-.19-1.52-.25a22.88,22.88,0,0,0-2.48-.12,20,20,0,0,0-4,.4A11.14,11.14,0,0,0,174.28,23a6.93,6.93,0,0,0-2.4,2.47,7.44,7.44,0,0,0-.9,3.78,8.88,8.88,0,0,0,.77,3.93A6.8,6.8,0,0,0,174,35.8a9.85,9.85,0,0,0,3.45,1.42,20.85,20.85,0,0,0,4.45.43,42.81,42.81,0,0,0,6.6-.45c1.7-.3,3.08-.53,4.08-.75a.36.36,0,0,0,.27-.35V21.47a15.26,15.26,0,0,0-.47-4.3m-6.55,14.48s0,.07-.05.07c-.35.05-.8.1-1.35.13s-1.3,0-2,0a6,6,0,0,1-3-.63,2.28,2.28,0,0,1-1.05-2.2,2.33,2.33,0,0,1,1.35-2.25,4.51,4.51,0,0,1,1.53-.45,14.56,14.56,0,0,1,1.87-.12,11.42,11.42,0,0,1,1.55.1c.48,0,.85.1,1.13.15,0,0,.05,0,.05.07Z",
    transform: "translate(-0.5 -0.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16164",
    "data-name": "Path 16164",
    className: "cls-1",
    d: "M160.35,17.86h8.13a.34.34,0,0,0,.35-.33V12.05a.35.35,0,0,0-.34-.35h-8.14a.06.06,0,0,1-.07,0V5.79a.35.35,0,0,0-.34-.35h-6.69a.35.35,0,0,0-.35.33V26.7a21.18,21.18,0,0,0,.45,4.49A8.09,8.09,0,0,0,155,34.64a7.67,7.67,0,0,0,3.1,2.23,12.85,12.85,0,0,0,4.87.8,17,17,0,0,0,3.9-.37,22.17,22.17,0,0,0,2.2-.65.33.33,0,0,0,.23-.35c-.15-1.76-.3-3.51-.45-5.29a.36.36,0,0,0-.4-.32l-.08,0a10.58,10.58,0,0,1-1.92.48,13.26,13.26,0,0,1-2.35.22c-1.55,0-2.58-.42-3.08-1.28a7.07,7.07,0,0,1-.77-3.53V17.94c.05-.05.07-.08.12-.08",
    transform: "translate(-0.5 -0.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16165",
    "data-name": "Path 16165",
    className: "cls-1",
    d: "M130.13,36.17c.18-1.85.38-3.7.55-5.52a.36.36,0,0,1,.4-.32l.08,0a22.36,22.36,0,0,0,3.42,1,17.5,17.5,0,0,0,3.75.4,6.92,6.92,0,0,0,2.72-.38A1.33,1.33,0,0,0,141.8,30a1.67,1.67,0,0,0-1-1.4,20.18,20.18,0,0,0-3.17-1.45,32.85,32.85,0,0,1-3-1.3,9.33,9.33,0,0,1-2.35-1.63,6.38,6.38,0,0,1-1.5-2.27,8.48,8.48,0,0,1-.52-3.15,6.86,6.86,0,0,1,2.67-5.68,11.67,11.67,0,0,1,7.27-2.07,22.68,22.68,0,0,1,4.43.4q1.46.3,2.55.6a.4.4,0,0,1,.25.37c-.2,1.75-.38,3.53-.58,5.28a.33.33,0,0,1-.37.31h-.08c-.75-.25-1.55-.48-2.4-.68A14.11,14.11,0,0,0,140.7,17c-2.17,0-3.22.57-3.22,1.75a2.22,2.22,0,0,0,.12.72,1.71,1.71,0,0,0,.53.6,7.23,7.23,0,0,0,1.15.65c.47.25,1.12.5,1.87.8A26.38,26.38,0,0,1,145,23.25a9.41,9.41,0,0,1,2.45,1.85,5.87,5.87,0,0,1,1.27,2.22,9.51,9.51,0,0,1,.38,2.8,6.5,6.5,0,0,1-2.85,5.73c-1.88,1.27-4.55,1.92-8,1.92a23.46,23.46,0,0,1-5.6-.57c-1-.25-1.72-.48-2.3-.65a.36.36,0,0,1-.27-.38",
    transform: "translate(-0.5 -0.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16166",
    "data-name": "Path 16166",
    className: "cls-1",
    d: "M125.25,36.73V12.08a.33.33,0,0,0-.33-.35h-6.67a.34.34,0,0,0-.35.33V36.75a.35.35,0,0,0,.34.35h6.66a.39.39,0,0,0,.35-.37",
    transform: "translate(-0.5 -0.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16167",
    "data-name": "Path 16167",
    className: "cls-1",
    d: "M102.31,27.88c-.38-1-.78-2.13-1.18-3.33-.45-1.37-.92-2.82-1.4-4.32s-.92-2.95-1.35-4.4c-.37-1.28-.72-2.5-1-3.6a.71.71,0,0,0-.68-.53h-6.8a.35.35,0,0,0-.34.35.34.34,0,0,0,0,.1c1.48,4.9,3,9.5,4.68,13.65s3.3,7.9,4.9,11.08a.33.33,0,0,0,.3.2h5.63a.34.34,0,0,0,.3-.2c1.6-3.15,3.24-6.88,4.9-11.08s3.2-8.77,4.67-13.65a.34.34,0,0,0-.22-.43l-.11,0H108a.71.71,0,0,0-.68.53c-.3,1.1-.62,2.32-1,3.6s-.88,2.9-1.35,4.4-.93,2.92-1.43,4.32c-.4,1.18-.8,2.3-1.17,3.33,0,.07,0,.07,0,0",
    transform: "translate(-0.5 -0.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16168",
    "data-name": "Path 16168",
    className: "cls-1",
    d: "M87.08,17.17a7.84,7.84,0,0,0-1.82-3.3,8.29,8.29,0,0,0-3.43-2.07,17,17,0,0,0-5.3-.73,20.33,20.33,0,0,0-2.47.13c-.8.07-1.6.17-2.33.3s-1.42.25-2,.37l-.9.23a.36.36,0,0,0-.25.37c.15,1.8.28,3.58.43,5.38a.33.33,0,0,0,.37.31h.08a14.25,14.25,0,0,1,2.75-.63,25.1,25.1,0,0,1,3.57-.25c1.78,0,3,.35,3.73,1.08a3.82,3.82,0,0,1,1.07,2.82v.43s0,.07-.1.07c-.5-.11-1-.19-1.52-.25a22.75,22.75,0,0,0-2.48-.12,20,20,0,0,0-4,.4A11.14,11.14,0,0,0,69,23a6.93,6.93,0,0,0-2.4,2.47,7.44,7.44,0,0,0-.9,3.78,8.88,8.88,0,0,0,.77,3.93,6.91,6.91,0,0,0,2.23,2.6,9.85,9.85,0,0,0,3.45,1.42,20.73,20.73,0,0,0,4.45.43,42.9,42.9,0,0,0,6.6-.45c1.7-.3,3.07-.53,4.07-.75a.37.37,0,0,0,.28-.35V21.47a14.87,14.87,0,0,0-.48-4.3M80.53,31.65a.07.07,0,0,1-.07.07c-.35.05-.8.1-1.35.13s-1.3,0-2,0a6,6,0,0,1-3-.63,2.28,2.28,0,0,1-1-2.2,2.39,2.39,0,0,1,.38-1.37,2.58,2.58,0,0,1,1-.88,4.69,4.69,0,0,1,1.52-.45,14.71,14.71,0,0,1,1.88-.12,11.82,11.82,0,0,1,1.57.1c.48,0,.85.1,1.13.15,0,0,0,0,0,.07v5.08Z",
    transform: "translate(-0.5 -0.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16169",
    "data-name": "Path 16169",
    className: "cls-2",
    d: "M42.61,23.37a13.9,13.9,0,0,0-3.7,1.68,20.4,20.4,0,0,0-3.2,2.5c-.73.67-1.43,1.37-2.13,2.1-.5.52-1,1.05-1.52,1.55a56.26,56.26,0,0,0,11.17,8.62,34.23,34.23,0,0,0,6.45,2.9,18.84,18.84,0,0,0,7,1,2.77,2.77,0,0,0,2.55-3A3,3,0,0,0,59,40,87.27,87.27,0,0,0,52.78,27.1c-.42-.38-.87-.73-1.3-1.1L50.26,25A7.9,7.9,0,0,0,45.08,23a9.88,9.88,0,0,0-2.47.35",
    transform: "translate(-0.5 -0.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16170",
    "data-name": "Path 16170",
    className: "cls-3",
    d: "M37.61,7.8a11.54,11.54,0,0,0-8-3.23,11.35,11.35,0,0,0-8,3.23A88.91,88.91,0,0,0,.56,39.19a.75.75,0,0,0,0,.7A7.68,7.68,0,0,0,4.21,43a9.7,9.7,0,0,0,2.18.62,12.06,12.06,0,0,0,2.55.15,15.76,15.76,0,0,0,2.27-.25c.82-.15,1.65-.35,2.48-.57a28.84,28.84,0,0,0,4.49-1.76,44.76,44.76,0,0,0,8.2-5.1c1.28-1,2.53-2,3.73-3.11.6-.55,1.2-1.1,1.77-1.68s1.13-1.12,1.68-1.7,1.4-1.42,2.12-2.1A21.43,21.43,0,0,1,38.88,25a13.65,13.65,0,0,1,3.7-1.65,8.08,8.08,0,0,1,7.65,1.58c.43.35.83.7,1.23,1s.87.73,1.3,1.1A87.49,87.49,0,0,0,37.61,7.8",
    transform: "translate(-0.5 -0.22)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAvistapp);
export default __webpack_public_path__ + "static/media/logo_avistapp.f25496e76a9d538731de5cb467663bad.svg";
export { ForwardRef as ReactComponent };